import type { Question } from '@/types/stresstest';
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

interface QuestionnaireState {
  questions: Question[];
  currentQuestionIndex: number;
  answers: Record<number, number>;
  isCompleted: boolean;
}

const initialState: QuestionnaireState = {
  questions: [
    { id: 1, question: 'stresstest.survey.question1.label' },
    { id: 2, question: 'stresstest.survey.question2.label' },
    { id: 3, question: 'stresstest.survey.question3.label' },
    { id: 4, question: 'stresstest.survey.question4.label' },
    { id: 5, question: 'stresstest.survey.question5.label' },
    { id: 6, question: 'stresstest.survey.question6.label' },
    { id: 7, question: 'stresstest.survey.question7.label' },
    { id: 8, question: 'stresstest.survey.question8.label' },
    { id: 9, question: 'stresstest.survey.question9.label' },
    { id: 10, question: 'stresstest.survey.question10.label' },
    { id: 11, question: 'stresstest.survey.question11.label' },
    { id: 12, question: 'stresstest.survey.question12.label' },
    { id: 13, question: 'stresstest.survey.question13.label' },
    { id: 14, question: 'stresstest.survey.question14.label' },
    { id: 15, question: 'stresstest.survey.question15.label' },
    { id: 16, question: 'stresstest.survey.question16.label' },
    { id: 17, question: 'stresstest.survey.question17.label' },
    { id: 18, question: 'stresstest.survey.question18.label' },
    { id: 19, question: 'stresstest.survey.question19.label' },
    { id: 20, question: 'stresstest.survey.question20.label' },
    { id: 21, question: 'stresstest.survey.question21.label' },
  ],
  currentQuestionIndex: 0,
  answers: {},
  isCompleted: false,
};

const questionnaireSlice = createSlice({
  name: 'questionnaire',
  initialState,
  reducers: {
    answerQuestion: (state, action: PayloadAction<{ questionId: number; answer: number }>) => {
      state.answers[action.payload.questionId] = action.payload.answer;

      if (state.currentQuestionIndex <= state.questions.length - 2) {
        state.currentQuestionIndex += 1;
      } else {
        state.isCompleted = true;
      }
    },
    resetQuestionnaire: (state) => {
      state.currentQuestionIndex = 0;
      state.answers = {};
    },
    setCurrentQuestionIndex: (state, action: PayloadAction<number>) => {
      state.currentQuestionIndex = action.payload;
    },
  },
});

export const { answerQuestion, resetQuestionnaire, setCurrentQuestionIndex } =
  questionnaireSlice.actions;
export default questionnaireSlice.reducer;
